
import Header from "./Header";
import Footer from "./Footer";

const PodLoadingState = () => {
  return (
    <div className="min-h-screen bg-[#f9f8f5]">
      <Header />
      <main className="pt-20">
        <div className="max-w-[800px] mx-auto px-4 desktop:px-24 laptop:px-20 tablet:px-12 mobile:px-6 py-12">
          <div className="flex justify-center items-center py-12">
            <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-[#374151]"></div>
          </div>
        </div>
      </main>
      <Footer />
    </div>
  );
};

export default PodLoadingState;
